/**
 * Title adornment for a search-filter candidate that names a person.
 *
 * The option only carries `personId`. What to draw belongs to the module that
 * owns that id, so its UI registers a renderer here. The filter panel reads
 * the same slot. Nothing registered, or a row with no person, draws nothing.
 */
export interface SearchFilterOptionAffixTarget {
  readonly personId?: string;
}

export type SearchFilterOptionAffixRenderer = (
  option: SearchFilterOptionAffixTarget,
) => unknown;

let renderer: SearchFilterOptionAffixRenderer | null = null;
const listeners = new Set<() => void>();

export function subscribeSearchFilterOptionAffix(
  listener: () => void,
): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

export function getSearchFilterOptionAffix(): SearchFilterOptionAffixRenderer | null {
  return renderer;
}

export function setSearchFilterOptionAffix(
  next: SearchFilterOptionAffixRenderer | null,
): void {
  renderer = next;
  for (const listener of listeners) {
    listener();
  }
}
